export const DEFAULT_ROW_HEIGHT = 55; /**in pixels */
